var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'spinner-border': true, ... _vm.classes}},[_c('span',{staticClass:"sr-only"})])
}
var staticRenderFns = []

export { render, staticRenderFns }